import { computed, Injectable, signal } from '@angular/core';

/** URLs that should NOT trigger the global loading indicator */
const SKIP_LOADING_URLS: string[] = [
  '/auth/send-otp',
  '/auth/verify-email',
];

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private activeRequests = signal(0);

  /** True when at least one tracked request is in flight */
  readonly isLoading = computed(() => this.activeRequests() > 0);

  show(): void {
    this.activeRequests.update((c) => c + 1);
  }

  hide(): void {
    this.activeRequests.update((c) => Math.max(0, c - 1));
  }

  /** Returns true if the given URL should skip the global loader */
  shouldSkip(url: string): boolean {
    return SKIP_LOADING_URLS.some((skip) => url.includes(skip));
  }
}
